export const ENRICHMENT_CREDITS_LABEL = 'enrichment credits';
export const VERIFICATION_CREDITS_LABEL = 'verification credits';
